import { useContext } from "react";

import classnames from "classnames";
import { UserContext } from "@context/user";
import { PAYMENT_MODEL, PAYMENT_MODEL_LABEL } from "@constants/panel/common";

// Ops-only header toggle for which payment model the workspace is looking at.
// Self payout brands settle with their publishers directly, so nothing is ever
// raised against them — debit notes and disbursements drop out of the nav
// (navigation/index.js) and off the routes (router/private-route.jsx) while it
// is selected.
const OPTIONS = [
    { value: PAYMENT_MODEL.MANAGED_PAYOUT, label: PAYMENT_MODEL_LABEL[PAYMENT_MODEL.MANAGED_PAYOUT] },
    { value: PAYMENT_MODEL.SELF_PAYOUT, label: PAYMENT_MODEL_LABEL[PAYMENT_MODEL.SELF_PAYOUT] }
];

const PaymentModelToggle = () => {
    const { userData, opsPaymentModel, setOpsPaymentModel } = useContext(UserContext);

    if (userData?.user?.role !== "ops") return null;

    return (
        <div
            role="group"
            aria-label="Payment model"
            className="flex items-center gap-0.5 rounded-lg border border-gray-200 bg-gray-50 p-0.5">
            {OPTIONS.map((option) => {
                const isActive = opsPaymentModel === option.value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => setOpsPaymentModel(option.value)}
                        className={classnames(
                            "rounded-md px-3 py-1 text-xs font-medium transition-colors",
                            isActive
                                ? "bg-white text-navy shadow-sm"
                                : "text-muted hover:text-gray-700"
                        )}>
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default PaymentModelToggle;
